import { render, staticRenderFns } from "./CloseWindow.vue?vue&type=template&id=0ca1f837&"
import script from "./CloseWindow.vue?vue&type=script&lang=js&"
export * from "./CloseWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports